export const waitMathJax = () => {
  setTimeout(() => {
    // @ts-ignore
    // eslint-disable-next-line no-undef
    MathJax.typeset()
  }, 5)
}
